<template>
    <div
        v-if="formattedDate"
        class="event-meta"
    >
        <template v-if="formattedDate">
            {{ formattedDate }}
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    event: {
        type: Object,
        required: true,
        default: null
    }
});

const formattedDate = computed(() => {
    if (props.event.dateRange) {
        return useDate().formatDateRange(props.event.dateRange.start, props.event.dateRange.end, useDate().formats.dayMonthYearAlt, useDate().formats.dayMonthAlt, useDate().formats.dayMonthAlt);
    } else {
        return `Published ${useDate().formatSingleDate(props.event.postDate, useDate().formats.dayMonthYear)}`;
    }
});
</script>

<style lang="less">
.event-meta {
    margin: 1.5rem 0;
    font-size: var(--font-size-sm);
}
</style>
